<template>
  <div class="employee-certification">
    <el-form label-width="140px">
      <el-row gutter="24">
        <el-col :span="11">
          <el-form-item label="姓名：">
            <el-input v-model="assessmentData.employee_name" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="工号：">
            <el-input v-model="assessmentData.employee_no" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row gutter="24">
        <el-col :span="11">
          <el-form-item label="部门：">
            <el-input v-model="assessmentData.department_ids" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="职级类型：">
            <el-input v-model="level_type" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row gutter="24">
        <el-col :span="11">
          <el-form-item label="当前职级：">
            <el-input v-model="assessmentData.current_level" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="当前称号：">
            <el-input v-model="assessmentData.current_title" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row gutter="24">
        <el-col :span="11">
          <el-form-item label="下一职级：">
            <el-input v-model="assessmentData.next_level" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="下级称号：">
            <el-input v-model="assessmentData.next_title" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row gutter="24">
        <el-col :span="11">
          <el-form-item label="开始从业日期：" >
            <el-input v-model="assessmentData.start_work_date" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="从业年限：" >
            <el-input v-model="assessmentData.work_years" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row gutter="24">
        <el-col :span="11">
          <el-form-item label="最低从业年限：" class="bold-label" label-position="left">
            <el-input v-model="assessmentData.min_year" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :offset="9" :span="4">
          <el-checkbox v-model="is_passed" disabled>达成</el-checkbox>
        </el-col>
      </el-row>
    </el-form>
    <el-row gutter="20">
      <el-col :span="10">
        <el-form-item label="晋升前置条件：" class="bold-label" label-width="180px" label-position="left">

        </el-form-item>
      </el-col>
    </el-row>
    <el-row gutter="20">
      <el-col :offset="2" :span="22">
        <el-table :data="assessmentData.certification_contents" style="width: 90%" :header-cell-style="headStyle">
          <el-table-column type="index" label="序号" width="100" align="right"></el-table-column>
          <el-table-column label="晋升前置条件" align="center">
            <template #default="scope">
              完成{{ scope.row.short_name }}认证
            </template>
          </el-table-column>
          <el-table-column label="达成" width="100" align="center">
            <template #default="scope">
              <el-checkbox v-model="is_passed" disabled></el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-row gutter="20">
      <el-col :span="10">
        <el-form-item label="考核前置条件：" class="bold-label" label-width="180px"
                      label-position="left">
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :offset="2" :span="22">
        <el-table :data="assessmentData.exam_condition_contents" style="width: 90%" :header-cell-style="headStyle">
          <el-table-column type="index" label="序号" width="100" align="right"></el-table-column>
          <el-table-column prop="condition" label="考核前置条件" align="center">
            <template #default="scope">
              {{ scope.row.exam_content }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="达成" width="100" align="center">
            <template #default="scope">
              <el-checkbox v-model="is_passed" disabled></el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <h4 style="margin-left: 5px">晋升考核：</h4>
    <el-form>
      <el-row gutter="24">
        <el-row :span="6">
          <el-form-item label="考核形式：" label-width="150px">
          </el-form-item>
          <el-checkbox-group v-model="assessmentData.exam_function" disabled>
            <el-checkbox label="笔试" value="written"></el-checkbox>
            <el-checkbox label="面试" value="interview"></el-checkbox>
            <el-checkbox label="提问" value="question"></el-checkbox>
          </el-checkbox-group>

        </el-row>
        <el-col :span="22">
          <el-form-item label="考官要求：" label-width="140px">
            <el-input v-model="assessmentData.exam_requirement" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <h4 style="margin-left: 5px">考核内容要求：</h4>
    <el-col :offset="2" gutter="24">
      <el-table :data="assessmentData.exam_contents" :header-cell-style="headStyle" stripe border
                style="width: 90%;margin-left: 5px">
        <el-table-column type="index" label="序号" width="80" align="center">
        </el-table-column>
        <el-table-column prop="exam_content" label="考核内容" width="auto" align="center"/>
        <el-table-column width="100" align="center">
          <template #default="scope">
            <el-checkbox v-model="is_passed" label="达成" disabled></el-checkbox>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    <h4 style="margin-left: 5px">职级评定：</h4>
    <el-form label-width="140px">
      <el-row gutter="24">
        <el-col :span="11">
          <el-form-item label="下一职级：">
            <el-input v-model="assessmentData.next_level" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="下级称号：">
            <el-input v-model="assessmentData.next_title" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="备注：">
            <el-input type="textarea" :rows="5" v-model="assessmentData.remark" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="考官：">
            <el-input v-model="assessmentData.examiner" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="晋升时间：">
            <el-input v-model="assessmentData.promotion_date" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "EmployeeLevelAssessmentDetail",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      level_type:'',
      assessmentData: {
        exam_contents: [],
        exam_requirement:'',
        exam_condition_contents:[],
        certification_contents:[],
        exam_function:[]
      },
      is_passed:true

    }
  },
  methods: {
    headStyle() {
      return {
        'background-color': '#f0f0f0',
      }
    },
    async getData() {
      this.level_type = this.parentData.level_type
      let params = {
        id: this.parentData.id,
      }
      await this.$http("employeeLevelService.getEmpLevelAssessmentDetailById", params)
          .then(res => {
            this.assessmentData = res
          })
    }
  },
  created() {
    this.getData()
  }

}
</script>

<style scoped lang="less">
:deep .bold-label .el-form-item__label {
  font-weight: bold;
  color: black;
}

.employee-certification {
  padding: 20px;
}

.certification-section {
  margin-top: 24px;
}

.save-button {
  text-align: center;
  margin-top: 24px;
}
</style>